import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/dallas/upscale_back.webp";
import { Link } from "gatsby";

function Dynamichouston() {
  return (
    <section
      className="dynamic_houston p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/location_new/dallas/upscale_dallas.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={486}
              height={651}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Upscale Your Digital Ecosystem with Dynamic Mobile Apps</h2>
            <p>
              We're a group of mobile experience fanatics determined to help
              entrepreneurs in Dallas by building meaningful and purpose-driven
              mobile applications for their businesses. From app developers in
              Dallas to quality assurance specialists to visionaries, TekRevol
              is home to some of the most experienced talents that supercharge
              your app idea and bring it to life. If you have a mobile app idea,
              we'd love to hear about it.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Dynamichouston;
